import React, { useEffect, useState, useCallback } from 'react'
import { useSelector } from 'react-redux'
import {
  AccordionAccordion,
  Accordion,
  Button,
  Table,
  Icon,
  ModalHeader,
  ModalDescription,
  ModalContent,
  ModalActions,
  Modal,
  Input,
  Label,
  Message,
  Popup,
} from 'semantic-ui-react'
import { toast } from 'react-toastify'

import api from '~/services/api'

import FormTabulacao from './FormTabulacao'
import { Container } from './style'

export default function Tabulacoes() {
  const profile = useSelector((state) => state.user.profile)
  const [tabulacoes, setTabulacoes] = useState([])

  const buscarTodasTabulacoes = useCallback(async () => {
    const { data } = await api.get(
      `/tabulacao/all/domain/${profile.id_dominio}`,
    )
    setTabulacoes(data)
  }, [profile.id_dominio])

  const [modalAddOpen, setModalAddOpen] = useState(false)
  const [tabulacaoInput, setTabulacaoInput] = useState('')
  const [idTabRoot, setIdTabRoot] = useState(null)

  const [modalDeleteOpen, setModalDeleteOpen] = useState(false)
  const [idTabDelete, setIdTabDelete] = useState(null)

  const [modalUpdateNameOpen, setModalUpdateNameOpen] = useState(false)
  const [idTabUpdateName, setIdTabUpdateName] = useState(null)
  const [tabulacaoUpdateNameInput, setTabulacaoUpdateNameInput] = useState('')

  const handleDeleteTabulacao = async (id) => {
    try {
      await api.delete(`/tabulacao/domain/${profile.id_dominio}/${id}`)
      buscarTodasTabulacoes()
      toast.success('Tabulação removida com sucesso')
    } catch (error) {
      toast.error('Erro ao remover tabulação')
    }
  }

  const handleChangeActive = async (id) => {
    try {
      await api.post(`/tabulacao/domain/${profile.id_dominio}/tabulacao/${id}`)
      buscarTodasTabulacoes()
      toast.success('Tabulação alterada com sucesso')
    } catch (error) {
      toast.error('Erro ao alterar tabulação')
    }
  }

  useEffect(() => {
    buscarTodasTabulacoes()
  }, [buscarTodasTabulacoes])

  const generatePanels = (tabulacoes) => {
    return tabulacoes.map((tabulacao) => {
      return {
        key: `panel-${tabulacao.id}`,
        title: {
          // tabulacao.nome
          content: (
            <Label
              color={tabulacao.ativo ? 'green' : 'red'}
              content={
                <div style={{}}>
                  {tabulacao.nome}
                  {' - '}
                  {tabulacao.ativo ? (
                    <Icon name="check" />
                  ) : (
                    <Icon name="times" />
                  )}
                </div>
              }
            />
          ),
        },
        content: {
          content: (
            <div>
              <Message
                attached
                header={
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div style={{ display: 'flex', gap: '5px' }}>
                      {tabulacao.nome}
                      <Popup
                        content="Editar o nome da tabulação"
                        trigger={
                          <Icon
                            name="edit outline"
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              // setTabulacaoInput(tabulacao.nome)
                              // setIdTabRoot(tabulacao.id)
                              // setModalAddOpen(true)
                              setTabulacaoUpdateNameInput(tabulacao.nome)
                              setIdTabUpdateName(tabulacao.id)
                              setModalUpdateNameOpen(true)
                            }}
                            color="yellow"
                          />
                        }
                      />
                    </div>
                    <div>
                      <Popup
                        content="Adicionar subnível"
                        trigger={
                          <Icon
                            name="plus"
                            style={{ cursor: 'pointer', marginRight: '10px' }}
                            onClick={() => {
                              setTabulacaoInput('')
                              setIdTabRoot(tabulacao.id)
                              setModalAddOpen(true)
                            }}
                            color="blue"
                            size="large"
                          />
                        }
                      />

                      <Popup
                        content="Habilitar/Desabilitar tabulação"
                        trigger={
                          <Icon
                            name={tabulacao.ativo ? 'toggle on' : 'toggle off'}
                            style={{ cursor: 'pointer', marginRight: '10px' }}
                            onClick={() => {
                              handleChangeActive(tabulacao.id)
                            }}
                            color={tabulacao.ativo ? 'green' : 'red'}
                            size="large"
                          />
                        }
                      />

                      <Popup
                        content="Remover"
                        trigger={
                          <Icon
                            name="trash alternate outline"
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              // handleChangeActive(tabulacao.id)
                              setIdTabDelete(tabulacao.id)
                              setModalDeleteOpen(true)
                            }}
                            size="large"
                            color="red"
                          />
                        }
                      />
                    </div>
                  </div>
                }
                // content="Fill out the form below to sign-up for a new account"
              />
              {!tabulacao.tabulations.length > 0 && (
                <FormTabulacao
                  idDominio={profile.id_dominio}
                  idTabulacao={tabulacao.id}
                />
              )}

              {tabulacao.tabulations.length > 0 && (
                <AccordionAccordion
                  // status={tabulacao.ativo}
                  panels={generatePanels(tabulacao.tabulations)}
                />
              )}
            </div>
          ),
        },
      }
    })
  }

  const handleAddTabulacao = async () => {
    try {
      await api.post(`/tabulacao/domain/${profile.id_dominio}`, {
        nome: tabulacaoInput,
        ativo: true,
        id_pai: idTabRoot,
      })

      buscarTodasTabulacoes()
      toast.success('Tabulação adicionada com sucesso')
    } catch (error) {
      toast.error('Erro ao adicionar tabulação')
    }
  }

  return (
    <Container>
      <Table celled color="blue">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell colSpan="7">
              <Button
                icon
                labelPosition="left"
                primary
                size="mini"
                onClick={() => {
                  setTabulacaoInput('')
                  setIdTabRoot(null)
                  setModalAddOpen(true)
                }}
              >
                <Icon name="sitemap" /> Adicionar Tabulação
              </Button>
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          <Accordion panels={generatePanels(tabulacoes)} styled />
        </Table.Body>
      </Table>

      <Modal
        onClose={() => setModalAddOpen(false)}
        onOpen={() => setModalAddOpen(true)}
        open={modalAddOpen}
      >
        <ModalHeader>Adicionar tabulação</ModalHeader>
        <ModalContent>
          <ModalDescription>
            <Input
              placeholder="Tabulação"
              onChange={(e) => setTabulacaoInput(e.target.value)}
              value={tabulacaoInput}
            />
          </ModalDescription>
        </ModalContent>
        <ModalActions>
          <Button color="black" onClick={() => setModalAddOpen(false)}>
            Cancelar
          </Button>
          <Button
            content="Adicionar"
            labelPosition="right"
            icon="checkmark"
            onClick={() => {
              handleAddTabulacao()
              setModalAddOpen(false)
            }}
            positive
          />
        </ModalActions>
      </Modal>

      <Modal
        onClose={() => setModalDeleteOpen(false)}
        onOpen={() => setModalDeleteOpen(true)}
        open={modalDeleteOpen}
      >
        <ModalHeader>Remover tabulação</ModalHeader>
        <ModalContent>
          <ModalDescription>
            Tem certeza que deseja remover esta tabulação? Esta ação não pode
            ser desfeita.
          </ModalDescription>
        </ModalContent>
        <ModalActions>
          <Button color="black" onClick={() => setModalDeleteOpen(false)}>
            Cancelar
          </Button>
          <Button
            content="Remover"
            labelPosition="right"
            icon="trash alternate outline"
            onClick={() => {
              handleDeleteTabulacao(idTabDelete)
              setModalDeleteOpen(false)
            }}
            negative
          />
        </ModalActions>
      </Modal>

      <Modal
        onClose={() => setModalUpdateNameOpen(false)}
        onOpen={() => setModalUpdateNameOpen(true)}
        open={modalUpdateNameOpen}
      >
        <ModalHeader>Editar nome da tabulação</ModalHeader>
        <ModalContent>
          <ModalDescription>
            <Input
              placeholder="Tabulação"
              onChange={(e) => setTabulacaoUpdateNameInput(e.target.value)}
              value={tabulacaoUpdateNameInput}
            />
          </ModalDescription>
        </ModalContent>
        <ModalActions>
          <Button color="black" onClick={() => setModalUpdateNameOpen(false)}>
            Cancelar
          </Button>
          <Button
            content="Alterar"
            labelPosition="right"
            icon="checkmark"
            onClick={async () => {
              try {
                await api.put(
                  `/tabulacao/domain/${profile.id_dominio}/${idTabUpdateName}`,
                  {
                    nome: tabulacaoUpdateNameInput,
                  },
                )
                buscarTodasTabulacoes()
                toast.success('Tabulação alterada com sucesso')
              } catch (error) {
                toast.error('Erro ao alterar tabulação')
              }
              setModalUpdateNameOpen(false)
            }}
            positive
          />
        </ModalActions>
      </Modal>
    </Container>
  )
}
